<template>
  <div class="newEnroll--container">
    <div v-show="!checkShow('mode')" class="shadow-card">
      <breadcrumbs v-show="!checkShow('mode')" :crumbs="mapping" :mapping="selectedMapping"></breadcrumbs>

      <div v-show="!checkShow('mode')" class="newEnroll--selected-params mrg-t-25">
        <div>
          <div class="item">
            <div>Услуги:</div>
            <div>{{ serviceNames }}</div>
          </div>
          <div class="item">
            <div>Продолжительность:</div>
            <div>{{ servicesDuration }}</div>
          </div>
          <div class="item">
            <div>Стоимость:</div>
            <div>{{ servicesPrice }}</div>
          </div>
          <div class="item">
            <div>Сотрудник:</div>
            <div>{{ selectedStaff }}</div>
          </div>
          <div class="item">
            <div>Дата:</div>
            <div>{{ normalizeDate }}</div>
          </div>
          <div class="item">
            <div>Время:</div>
            <div>{{ normalizeTime }}</div>
          </div>
        </div>

      </div>
    </div>

    <div v-show="!checkShow('mode')" class="newEnroll--actions shadow-card">
      <div
        v-show="!checkShow('client')"
        @click="move('next')"
        class="btn btn-sm btn-info mrg-t-10"
      >
        Продолжить
      </div>
      <div @click="move('prev')" class="btn btn-sm btn-outline-info mrg-t-10">
        <f-awesome icon="arrow-left"></f-awesome> Назад
      </div>
      <div
        v-show="!checkShow('client')"
        @click="resetChildSelect"
        class="btn btn-sm btn-outline-info mrg-t-10"
      >
        Сбросить выбор
      </div>
    </div>


    <div
      v-if="isGroupAndNeedLoadInfo && groupParticipantsData && groupParticipantsData.show_participant"
      class="alert alert-sm alert-info mrg-b-10"
    >
      {{ groupParticipantsData.text }}
    </div>


    <div v-if="checkShow('mode')" class="newEnroll--select-mode">
      <div @click="setMode('service')" class="item">
        <div>
          <f-awesome icon="list"></f-awesome>
        </div>
        <div>Выбрать услугу</div>
      </div>
      <div @click="setMode('staff')" class="item">
        <div>
          <f-awesome icon="users"></f-awesome>
        </div>
        <div>Выбрать сотрудника</div>
      </div>
    </div>
    <div v-show="checkShow('services')" class="newEnroll--select-services mrg-t-25">
      <div class="mrg-t-10 text-orange minimal_enroll_sum">
        {{minimalEnrollSumText}}
      </div>
      <select-services
        :selectReset="resetSelectServices"
        :componentReset="resetComponentService"
        :rerender="checkShow('services')"
        :staff="selectedStaffObject"
        :multiple_services="+all_config.multiple_services"
        @next="move('next')"
        @selectServices="setServices"
        @selectAndNext="setServicesAndNext"
      ></select-services>
    </div>
    <div v-show="checkShow('staff')" class="newEnroll--select-staff mrg-t-25">
      <select-staff
        @selectStaff="setStaff"
        @selectAndNext="setStaffAndNext"
        :rerender="checkShow('staff')"
        :selectReset="resetSelectStaff"
        :componentReset="resetComponentStaff"
        :services="selected.services"
      ></select-staff>
    </div>
    <div v-show="checkShow('time')" class="newEnroll--select-time mrg-t-25">
      <select-calendar-and-interval
        @selectDate="setDate"
        @selectTime="setTime"
        :reset="resetSelectTime"
        :staff="selectedStaffId"
        :duration="servicesDurationMinute"
        :rerender="resetComponentTime"
        :selected-services="selected.services"
      ></select-calendar-and-interval>
    </div>
    <div v-show="checkShow('client')" class="newEnroll--select-client">
      <select-client
        :show="checkShow('client')"
        :reset="resetComponentClient"
        :isGroup="isGroupAndNeedLoadInfo"
        @createEnroll="createNewEnroll"
      ></select-client>
    </div>
  </div>
</template>

<script>
import Formatter from "../../../libraries/Formatter";
const formatter = new Formatter();

import SelectServices from "./SelectServices";
import SelectStaff from "./SelectStaff";
import SelectCalendarAndInterval from "./SelectCalendarAndInterval";
import SelectClient from "./SelectClient";
import Breadcrumbs from "../../../Breadcrumbs";
import configRepository from "../../../../repositories/config";
import journalRepository from "../../../../repositories/journal";
import enrollRepository from "../../../../repositories/enroll";

export default {
  name: "NewEnroll",
  components: {
    Breadcrumbs,
    SelectClient,
    SelectCalendarAndInterval,
    SelectStaff,
    SelectServices
  },
  data() {
    return {
      mode: null,
      mapping: [
        {
          block: "mode",
          active: true,
          name: 'Режим'
        },
        {
          block: "services",
          active: false,
          name: 'Услуга'
        },
        {
          block: "staff",
          active: false,
          name: 'Сотрудник'
        },
        {
          block: "time",
          active: false,
          name: 'Время'
        },
        {
          block: "client",
          active: false,
          name: 'Клиент'
        }
      ],
      mappingServices: ["mode", "services", "staff", "time", "client"],
      mappingStaff: ["mode", "staff", "services", "time", "client"],
      selected: {
        services: [],
        staff: null,
        date: "",
        time: ""
      },
      all_config: {},
      company_config: {},
      resetSelectServices: 0, // счетчик для сброса компонента выбора услуг
      resetSelectStaff: 0, // счетчик для сброса компонента выбора сотрудника
      resetComponentService: 0,
      resetComponentStaff: 0,
      resetComponentTime: 0,
      resetSelectTime: 0,
      resetComponentClient: 0,
      groupParticipantsData: {}
    };
  },
  props: {
    reset: Number
  },
  watch: {
    reset: function() {
      this.resetComponent();
    },
    isGroupAndNeedLoadInfo: function(val){
      if(val === true){
        this.loadGroupParticipants();
      }
    }
  },
  computed: {
    isGroupAndNeedLoadInfo(){
      let result = false;
      let isGroup = false;
      if(this.selected.services.length > 0){
        for(let key in this.selected.services){
          if(+this.selected.services[key].is_group === 1){
            isGroup = true;
          }
        }
        if(isGroup){
          if(
            this.selected.staff !== null &&
            this.selected.date !== "" &&
            this.selected.time !== ""
          ){
            result = true;
          }
        }
      }
      return result;
    },
    selectedMapping(){
      let result = [];

      if(this.mode === "service"){
        result = this.mappingServices;
      }else if(this.mode === "staff"){
        result = this.mappingStaff;
      }
      return result;
    },
    serviceNames() {
      let result = [];
      for (let key in this.selected.services) {
        result[result.length] = this.selected.services[key].name;
      }
      return result.join("; ");
    },
    serviceIds() {
      let result = [];
      for (let key in this.selected.services) {
        result[result.length] = this.selected.services[key].id;
      }
      return result;
    },
    servicesDuration() {
      let duration = 0;
      for (let key in this.selected.services) {
        duration += formatter.hourMinuteToMinute(
          this.selected.services[key].time_hour,
          this.selected.services[key].time_minute
        );
      }
      return formatter.minuteToTime(duration);
    },
    servicesDurationMinute() {
      let duration = 0;
      for (let key in this.selected.services) {
        duration += formatter.hourMinuteToMinute(
          this.selected.services[key].time_hour,
          this.selected.services[key].time_minute
        );
      }
      return duration;
    },
    servicesPrice() {
      let price = 0;
      for (let key in this.selected.services) {
        price += +this.selected.services[key].price;
      }
      return price;
    },
    minimalEnrollSumText(){
      let result = '';
      if(
        this.company_config &&
        +this.company_config.use_minimal_enroll_sum === 1 &&
        this.servicesPrice < +this.company_config.minimal_enroll_sum
      ){
        result = 'Минимальная сумма записи: ' +this.company_config.minimal_enroll_sum;
      }
      return result;
    },
    selectedStaff() {
      let name = "";
      if (this.selected.staff !== null) {
        name = this.selected.staff.name;
      }
      return name;
    },
    selectedStaffId() {
      let id = 0;
      if (this.selected.staff !== null) {
        id = this.selected.staff.id;
      }
      return +id;
    },
    selectedStaffObject() {
      let result = {};
      if (this.selected.staff !== null) {
        result = this.selected.staff;
      }
      return result;
    },
    getServicesMode() {
      let result = 0;
      if (this.selected.staff != null) {
        result = 1;
      }
      return result;
    },
    normalizeDate() {
      let result = "";
      if (this.selected.date != "") {
        result = formatter.phpDateToString(this.selected.date);
      }
      return result;
    },
    normalizeTime() {
      let result = "";
      if (this.selected.time !== "") {
        result = formatter.minuteToTime(this.selected.time);
      }
      return result;
    }
  },
  methods: {
    loadGroupParticipants(){
      journalRepository.getGroupParticipants({
        service: {
          service_id: this.selected.services[0].service_id,
          modification_id: this.selected.services[0].modification_id
        },
        staff: this.selected.staff.id,
        date: this.selected.date,
        time: this.selected.time
      }).then(resp => {
        this.groupParticipantsData = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    setMode(val) {
      this.mode = val;
      this.move("next");
    },
    getNowScreen() {
      let result = "";
      for (let key in this.mapping) {
        if (this.mapping[key].active) {
          result = this.mapping[key].block;
          break;
        }
      }
      return result;
    },
    /**
     *
     * @param action - next\prev
     */
    move(action) {
      let nowScreen = this.getNowScreen();
      let nextScreen = "";

      if (
        nowScreen === "services" &&
        !this.selected.services.length &&
        action === "next"
      ) {
        this.$store.dispatch("addNotification", {
          text: "Не выбрана ни одна услуга",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (
        nowScreen === "staff" &&
        this.selected.staff == null &&
        action === "next"
      ) {
        this.$store.dispatch("addNotification", {
          text: "Пожалуйста, выберите сотрудника",
          time: 3,
          color: "danger"
        });
        return false;
      }
      if (nowScreen === "time" && this.selected.time === "" && action === "next") {
        this.$store.dispatch("addNotification", {
          text: "Не выбрано время записи",
          time: 3,
          color: "danger"
        });
        return false;
      }
      // Сбросим компонент, если делаем шаг назад
      if (action === "prev") {
        this.resetChildComponent();
      }

      let mapping =
        this.mode === "service" ? this.mappingServices : this.mappingStaff;

      for (let key in mapping) {
        if (mapping[key] === nowScreen) {
          let nKey = 0;
          if (action === "next") {
            nKey = +key + 1;
          } else if (action === "prev") {
            nKey = +key - 1;
          }
          nextScreen = mapping[nKey];
          break;
        }
      }
      if (action === "next" && nextScreen === "time") {
        this.resetComponentTime = this.resetComponentTime + 1;
      }
      this.moveTo(nextScreen);
    },
    moveTo(block) {
      // if(block == 'mode'){
      //     this.resetSelectServices = this.resetSelectServices +1;
      //     this.resetSelectStaff = this.resetSelectStaff +1;
      // }
      for (let key in this.mapping) {
        if (this.mapping[key].block == block) {
          this.mapping[key].active = true;
        } else {
          this.mapping[key].active = false;
        }
      }
    },
    resetComponent() {
      this.mode = null;
      this.selected.services = [];
      this.selected.staff = null;
      this.selected.date = "";
      this.selected.time = "";
      this.resetComponentService = this.resetComponentService + 1;
      this.resetComponentStaff = this.resetComponentStaff + 1;
      this.resetComponentClient = this.resetComponentClient + 1;
      this.moveTo("mode");
    },
    // Сбросить выбор
    resetChildSelect() {
      let nowScreen = this.getNowScreen();
      if (nowScreen === "services") {
        this.resetSelectServices = this.resetSelectServices + 1;
      }
      if (nowScreen === "staff") {
        this.resetSelectStaff = this.resetSelectStaff + 1;
      }
      if (nowScreen === "time") {
        this.resetSelectTime = this.resetSelectTime + 1;
      }
      if (nowScreen === "client") {
        this.resetComponentClient = this.resetComponentClient + 1;
      }
    },
    // Сброс компонента при шаге назад
    resetChildComponent() {
      let nowScreen = this.getNowScreen();
      if (nowScreen === "services") {
        this.resetComponentService = this.resetComponentService + 1;
      }
      if (nowScreen === "staff") {
        this.resetComponentStaff = this.resetComponentStaff + 1;
      }
      if (nowScreen === "time") {
        this.resetSelectTime = this.resetSelectTime + 1;
      }
      if (nowScreen === "client") {
        this.resetComponentClient = this.resetComponentClient + 1;
      }
    },
    checkShow(block) {
      let result = false;
      for (let key in this.mapping) {
        if (this.mapping[key].block === block) {
          result = this.mapping[key].active;
        }
      }
      return result;
    },
    setServices(val) {
      this.$set(this.selected, "services", val);
    },
    setServicesAndNext(val) {
      this.$set(this.selected, "services", val);
      this.move('next');
    },
    setStaff(val) {
      this.$set(this.selected, "staff", val);
    },
    setStaffAndNext(val) {
      this.$set(this.selected, "staff", val);
      this.move('next');
    },
    setDate(val) {
      this.$set(this.selected, "date", val);
    },
    setTime(val) {
      this.$set(this.selected, "time", val);
    },
    async createNewEnroll(val) {
      let formData = new FormData();
      const data = {
        confirm: val.confirm,
        staff: this.selectedStaffId,
        date: this.selected.date,
        time: this.selected.time,
        exclude_enroll_old_today: true,
        is_group: this.isGroupAndNeedLoadInfo ? 1 : 0,
        send_sms_client: val.send_sms
      };

      let method = 'setEnroll';
      //let urlAction = "/enroll/set-enroll";

       //const methodName = `${actionType}Enroll`;
       //const data = { /* ваш набор данных */
      //enrollRepository[methodName](data)

      //let clientCnt = 0;
      //let formKey = 'enroll_clients[' +clientCnt +']';
      // Если групповая, то немного притворимся
      const enrollClients = [];

      if(this.isGroupAndNeedLoadInfo){
        let searchEnroll = await this.searchGroupEnroll();
        if(searchEnroll.enrollClients){
          for(let enrollClientKey in searchEnroll.enrollClients){
            let client = {};
            //formKey = 'enroll_clients[' +clientCnt +']';
            if(searchEnroll.enrollClients[enrollClientKey]['add_field']){
              client.add_field = searchEnroll.enrollClients[enrollClientKey]['add_field'];
              //formData.append(formKey +'[add_field]', searchEnroll.enrollClients[enrollClientKey]['add_field']);
            }else{
              client.add_field = '';
              //formData.append(formKey +'[add_field]', '');
            }

            if(searchEnroll.enrollClients[enrollClientKey]['comment']){
              client.comment = searchEnroll.enrollClients[enrollClientKey]['comment'];
              //formData.append(formKey +'[comment]', searchEnroll.enrollClients[enrollClientKey]['comment']);
            }else{
              client.comment = '';
              //formData.append(formKey +'[comment]', '');
            }

            client.number = searchEnroll.enrollClients[enrollClientKey]['clients']['number'];
            client.is_canceled = searchEnroll.enrollClients[enrollClientKey]['is_canceled'];
            //formData.append(formKey +'[number]', searchEnroll.enrollClients[enrollClientKey]['clients']['number']);
            //formData.append(formKey +'[is_canceled]', searchEnroll.enrollClients[enrollClientKey]['is_canceled']);
            if(searchEnroll.enrollClients[enrollClientKey]['cancel_reason']){
              client.cancel_reason = searchEnroll.enrollClients[enrollClientKey]['cancel_reason'];
              //formData.append(formKey +'[cancel_reason]', searchEnroll.enrollClients[enrollClientKey]['cancel_reason']);
            }
            //clientCnt++;
            enrollClients.push(client);
          }
          // Сменим URL
          data.update_enroll_id = searchEnroll.id;
          //formData.append("update_enroll_id", searchEnroll.id);
          method = 'updateEnroll';
          //urlAction = "/enroll/update-enroll";
        }
      }else{
        data.comment_company = val.comment;
        data.source_client_id = val.source_client_id;
        data.remind_before_hour = val.remind_before_hour;
        //formData.append("comment_company", val.comment);
        //formData.append("source_client_id", val.source_client_id);
        //formData.append("remind_before_hour", val.remind_before_hour);
      }

      // Добавим текущего клиента в любом случае
      //formKey = 'enroll_clients[' +clientCnt +']';
      let client = {};
      if(val.add_field){
        client.add_field = val.add_field;
        //formData.append(formKey +'[add_field]', val.add_field);
      }
      client.number = val.number;
      client.client_modification_id = val.client_modification_id;

      enrollClients.push(client);
      data.enroll_clients = enrollClients;

      //formData.append(formKey +'[number]', val.number);
      //formData.append(formKey +'[client_modification_id]', val.client_modification_id);
      let services = [];
      for(let servKey in this.selected.services){
        let service = {
          service_id: this.selected.services[servKey]['service_id'],
          modification_id: this.selected.services[servKey]['modification_id'],
          category_name: this.selected.services[servKey]['category_name'],
          name: this.selected.services[servKey]['name'],
          price: this.selected.services[servKey]['price'],
          time_hour: this.selected.services[servKey]['time_hour'],
          time_minute: this.selected.services[servKey]['time_minute']
        };
        services.push(service);
        //let formKey = 'services[' +servKey +']';
        //formData.append(formKey +'[service_id]', this.selected.services[servKey]['service_id']);
        //formData.append(formKey +'[modification_id]', this.selected.services[servKey]['modification_id']);
        //formData.append(formKey +'[category_name]', this.selected.services[servKey]['category_name']);
        //formData.append(formKey +'[name]', this.selected.services[servKey]['name']);
        //formData.append(formKey +'[price]', this.selected.services[servKey]['price']);
        //formData.append(formKey +'[time_hour]', this.selected.services[servKey]['time_hour']);
        //formData.append(formKey +'[time_minute]', this.selected.services[servKey]['time_minute']);
      }

      data.services = services;

      this.$store.dispatch("startPreloader");

      enrollRepository[method](data).then(resp => {
        if (resp.data.result === "ok") {
          this.$store.dispatch("addNotification", {
            text: "Запись успешно добавлена",
            time: 3,
            color: "success"
          });
          this.$emit("closeAndUpdate");
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
      // axios
      //   .post(urlAction, formData)
      //   .then(resp => {
      //     if (resp.data.result == "ok") {
      //       this.$store.dispatch("addNotification", {
      //         text: "Запись успешно добавлена",
      //         time: 3,
      //         color: "success"
      //       });
      //       this.$emit("closeAndUpdate");
      //     }
      //     this.$store.dispatch("stopPreloader");
      //   })
      //   .catch(err => {
      //     this.$store.dispatch("addNotification", {
      //       text: err.response.data.message,
      //       time: 6,
      //       color: "danger"
      //     });
      //     this.$store.dispatch("stopPreloader");
      //   });
    },
    searchGroupEnroll(){
      const data = {
        staff: this.selectedStaffId,
        date: this.selected.date,
        time: this.selected.time
      };
      const services = [];
      for(let servKey in this.selected.services){
        let service = {
          service_id: this.selected.services[servKey]['service_id'],
          modification_id: this.selected.services[servKey]['modification_id']
        };
        services.push(service);
      }
      data.services = services;

      return enrollRepository.searchGroupByParams(data).then(resp => {
        return resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    }
  },
  created() {
    this.$store.dispatch("startPreloader");
    configRepository.fullConfigCurrentCompany().then(resp => {
      this.all_config = resp.data.result.main_config;
      this.company_config = resp.data.result.company_config;
      this.$store.dispatch("stopPreloader");
    }).catch(err => {
      this.$store.dispatch("addNotification", {
        text: err.response.data.message,
        time: 6,
        color: "danger"
      });
      this.$store.dispatch("stopPreloader");
    });
  }
};
</script>

<style scoped lang="less">
.newEnroll--back-action {
  text-align: left;
  margin-bottom: 8px;

  svg {
    font-size: 23px;
    cursor: pointer;
    color: #dc3545;
  }
}
.newEnroll--actions {
  margin-top: 25px;
  margin-bottom: 25px;
}
.newEnroll--selected-params {
  margin-bottom: 10px;
  color: #4f4f4f;
  font-size: 12px;

  & > div {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    flex-direction: row;

    .item {
      width: 16.5%;
      text-align: center;

      & > div:nth-of-type(1) {
        font-weight: 500;
      }
      & > div:nth-of-type(2) {
        margin-top: 4px;
      }
    }
  }
}
.newEnroll--select-mode {
  margin-top: 45px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  flex-direction: row;

  .item {
    cursor: pointer;
    width: 160px;
    text-align: center;
    margin: 0 10px;

    & > div:nth-of-type(1) {
      font-size: 46px;
      color: #c4c4c4;
    }
    & > div:nth-of-type(2) {
      margin-top: 8px;
      font-size: 16px;
      font-weight: 500;
      color: #41a2fc;
      border-bottom: 3px solid #41a2fc;
    }
  }
}
.minimal_enroll_sum{
  font-size: 12px;
}
@media (max-width: 600px) {
  .newEnroll--selected-params {

    & > div {
      flex-wrap: wrap;

      .item {
        margin-bottom: 10px;
        width: 45%;
      }
    }
  }
}
@media (max-width: 400px){
  .newEnroll--select-mode {
    margin-top: 25px;
    flex-wrap: wrap;

    .item {
      width: 100%;
      margin: 20px 10px;

      & > div:nth-of-type(2) {
        border-bottom: none;
      }
    }
  }
}
</style>
